import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/ui/Icon';
import { NewsGrid } from './newsComponents';
import { usePublishedPosts } from './useNews';

// Homepage "Latest news" strip: the three newest published posts. Renders
// nothing until there is at least one, so the homepage never shows an empty
// news section.
export default function LatestNews() {
  const { posts } = usePublishedPosts('/', { limit: 3 });
  if (posts.length === 0) return null;

  return (
    <section id="news" className="news-section" aria-labelledby="news-heading">
      <div className="news-section-header">
        <div>
          <p className="news-eyebrow">News &amp; updates</p>
          <h2 id="news-heading" className="news-section-title">
            Latest from Qentoros
          </h2>
        </div>
        <Link to="/news" className="news-all-link">
          View all news <Icon name="arrow_forward" aria-hidden="true" />
        </Link>
      </div>
      <NewsGrid posts={posts} />
    </section>
  );
}
